import React from "react"
import PropTypes from "prop-types"

const HelloWorld = (props) => {
  return (
    <div className="w-full h-52">
        <div className="text-5xl font-bold">Greeting: {props.greeting}</div>
    </div>
  )
}

HelloWorld.propTypes = {
  greeting: PropTypes.string
};

export default HelloWorld
